// Building Zoo-skin scenes from a period's sounds (one creature per sound).
import {
  FIRST_ATMOS,
  getAtmosKit,
  hashString,
  INSTRUMENT_ROLES,
  KITS,
  ROLE_LABEL,
  type PeriodDef,
  type PeriodSpec,
} from "@eb/shared";
import { speciesForSound, type ZooScene } from "../zoo";
import { prefersCalm } from "../ui/settings";
import { useMedia } from "../ui/useMedia";

export function zooScene(def: PeriodDef, spec: PeriodSpec): ZooScene {
  return {
    habitat: KITS[def.kit].habitat,
    // Drums and instruments one creature each; the whole atmos kit is one creature (slot 20).
    creatures: spec.sounds.slice(0, FIRST_ATMOS + 1).map((s, slot) => ({
      slot,
      name:
        slot < 16
          ? s.name
          : slot === FIRST_ATMOS
            ? `Atmos: ${getAtmosKit(def.atmosKit).name}`
            : `${ROLE_LABEL[INSTRUMENT_ROLES[slot - 16]]}: ${s.name}`,
      species: slot === FIRST_ATMOS ? "glimmer" : speciesForSound(s.name, slot, s.synth?.model ?? null),
      // Stable per day + sound, so a day's creatures look the same for everyone.
      seed: hashString(`${def.day}:${def.kit}:${slot}:${s.name}`),
    })),
  };
}

/** Calm motion: the toggle or the OS setting. */
export function useCalm(): boolean {
  const reduced = useMedia("(prefers-reduced-motion: reduce)");
  return reduced || prefersCalm();
}
